import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useLocation, useParams } from "react-router-dom";
import i18n from "../../helpers/i18n";
import { resetUserData } from "../../reducer/actions";
import ExclusiveModal from "../common/exclusive-modal";
import { LOGOUT_API } from "../../services/common/endpoints";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { GTM_Logout } from "../../../src/analytics/GoogleTagManager"

import {
  getItem,
  getItemOfSessionStorage,
  setItem,
} from "../../services/common/utils";
import { SELECTED_LANG } from "../../services/common/Constants";
import { setSelectedMenu } from "../../reducer/actions";
import SidebarModal from "./sidebar-modal";
import {CT_Events} from "../../../src/analytics/CTEvents";
import { resetCdrReduxData } from "../../reducer/cdrSlice";
const SidebarComponent = () => {
  const x = getItemOfSessionStorage(SELECTED_LANG);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [enableLogoutApi, setenableLogoutApi] = useState(false);
  const [shopUrl, setshopUrl] = useState("");
  const [showLogOut, setshowLogOut] = useState(false);
  const [deeplinktext, setDeeplinktext] = useState("");
  const [showBottomModal, setShowBottomModal] = useState(false);
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  const [isAura, setIsAura] = useState(false);


  const customerprofile = useSelector(
    (state) => state?.userdata?.value?.customerprofile || {}
  );


  const {CT_Logout} = CT_Events();
  const location = useLocation();
  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const bootomToggleModal = () => {
    setShowBottomModal(!showBottomModal);
  };

  const tokenid = useSelector((state) => state?.userdata?.value?.tokenid);

  const selectorMenu = useSelector(
    (state) => state?.userdata?.value?.SelectedMenu
  );


  const { id } = useParams();

  useEffect(() => {
    setshowLogOut(tokenid);
  }, [tokenid]);
  const locationArray = ["/home/index","/home","/paybill", "/nojoom", "/moremenu", '/more'];
  const homeMenuActivePaths = ['/manage-account'];
  useEffect(() => {
   try{
     if(location.pathname == "/home" || location.pathname == "/index")
        location.pathname ="/home/index";
   }catch{}

    if(locationArray.includes(location.pathname)){
      dispatch(setSelectedMenu(location.pathname));
    }

    if(homeMenuActivePaths.includes(location.pathname)){
      dispatch(setSelectedMenu('/home'));
    }
  }, [location]);

  try {
    useEffect(() => {
      (async () => {
        var _lang = await getItem(SELECTED_LANG);
        if (_lang == "en") {
          setshopUrl("https://shop.ooredoo.com.kw/EN/");
        } else {
          setshopUrl("https://shop.ooredoo.com.kw/AR/");
        }
      })();

      if(customerprofile != null && customerprofile != undefined && customerprofile != null
        && customerprofile != "undefined")
      {
        setIsAura(customerprofile?.IsAuraMobile);
      }
      
    }, []);
  } catch {}

  const {
    data: { data } = {},
    isLoading,
    isFetching,
    isSuccess,
  } = useQuery(["", LOGOUT_API, {}, {}, false], {
    enabled: enableLogoutApi,
    retry: false,
  });
  const { t } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(x);
  }, []);

  useEffect(() => {
    if (data?.status == "0") {
      try {
        sessionStorage.clear();
        try{
          var _savedLogin = localStorage.getItem("sl")
          localStorage.clear();
          if(_savedLogin != null && _savedLogin != undefined && _savedLogin != ""
          && _savedLogin != "undefined"){
           localStorage.setItem("sl",_savedLogin)
          }
           }catch{}
      } catch (e) {}
      navigate("/#");
    } else {
    }
  }, [isSuccess]);

  const logoutclick = () => {
    let _lang = getItemOfSessionStorage(SELECTED_LANG);
    try{
      GTM_Logout("Dashboard", msisdn, logintype, "Success");
      CT_Logout();
    }catch{}
    dispatch(resetUserData());
    dispatch(resetCdrReduxData());
    setenableLogoutApi(true);
    sessionStorage.clear();
    try{
      var _savedLogin = localStorage.getItem("sl")
      localStorage.clear();
      if(_savedLogin != null && _savedLogin != undefined && _savedLogin != ""
      && _savedLogin != "undefined"){
       localStorage.setItem("sl",_savedLogin)
      }
       }catch{}
    setItem(SELECTED_LANG, _lang);
    navigate("/#");
  };

  return (
    <section className="side_menu_wrapper">
      <div className="side_menu_wrapper_inside">
        <div className="side_menu_top">
          <a href="" className="side_menu_logo">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/logo_red.svg"}
              alt=""
              title=""
            />
          </a>
        </div>
        <ul className="side_menu_list">
          {showLogOut ? (
            <>
              <li
              >
                <NavLink
                  to="/home/index"
                  activeClassName="nav-link--active"
                  className={(selectorMenu === "/home/index" || selectorMenu === "/home") ? "side_menu_item active"  :"side_menu_item"  }
                >
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/images/home_black.svg"
                    }
                    className="black_icon"
                    alt=""
                    title=""
                  />
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/images/home_gray.svg"
                    }
                    className="gray_icon"
                    alt=""
                    title=""
                  />
                  <span>{t("home")}</span>
                </NavLink>
              </li>
            </>
          ) : (
            <>
              <li>
                <Link
                  to=""
                  activeClassName="nav-link--active"
                  className={selectorMenu === "/home/index" ?"side_menu_item active" : "side_menu_item"  }
                >
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/images/home_black.svg"
                    }
                    className="black_icon"
                    alt=""
                    title=""
                  />
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/images/home_gray.svg"
                    }
                    className="gray_icon"
                    alt=""
                    title=""
                  />
                  <span>{t("home")}</span>
                </Link>
              </li>
            </>
          )}

          <li
          >
            <NavLink
              to="/paybill"
              activeClassName="nav-link--active"
              className={selectorMenu === "/paybill" ?"side_menu_item active" : "side_menu_item"  }
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/pay_black.svg"}
                className="black_icon"
                alt=""
                title=""
              />
              <img
                src={process.env.PUBLIC_URL + "/assets/images/pay_gray.svg"}
                className="gray_icon"
                alt=""
                title=""
              />
              <span>{t("pay")}</span>
            </NavLink>
          </li>
          <li>
            <a href={shopUrl} target="blank" className="side_menu_item">
              <img
                src={process.env.PUBLIC_URL + "/assets/images/shop_black.svg"}
                className="black_icon"
                alt=""
                title=""
              />
              <img
                src={process.env.PUBLIC_URL + "/assets/images/shop_gray.svg"}
                className="gray_icon"
                alt=""
                title=""
              />
              <span>{t("shop")}</span>
            </a>
          </li>
           {
            isAura == false && 
            ( <li>
              <NavLink
                to="/nojoom"
                activeClassName="nav-link--active"
                className={selectorMenu === "/nojoom" ? "side_menu_item active" : "side_menu_item" }
              >
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/nojoom_black.svg"}
                  className="black_icon"
                  alt=""
                  title=""
                />
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/nojoom_gray.svg"}
                  className="gray_icon"
                  alt=""
                  title=""
                />
                <span>{t("nojoom")}</span>
              </NavLink>
            </li>)
           }
         
          <li
          >
            <NavLink
              to="/more"
              activeClassName="nav-link--active"
              className={(selectorMenu === "/more") ? "side_menu_item active" : "side_menu_item" }
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/images/more_black.svg"}
                className="black_icon"
                alt=""
                title=""
              />
              <img
                src={process.env.PUBLIC_URL + "/assets/images/more_gray.svg"}
                className="gray_icon"
                alt=""
                title=""
              />
              <span>{t("more")}</span>
            </NavLink>
          </li>
          {showLogOut ? (
            <>
              <li>
                <a className="side_menu_item" onClick={bootomToggleModal}>
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/images/logout_black.svg"
                    }
                    className="black_icon"
                    alt=""
                    title=""
                  />
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/images/logout_gray.svg"
                    }
                    className="gray_icon"
                    alt=""
                    title=""
                  />
                  <span>{t("logout")}</span>
                </a>
              </li>
            </>
          ) : (
            <></>
          )}
        </ul>
      </div>

      <SidebarModal
        show={showBottomModal}
        toggleModal={bootomToggleModal}
        logoutOk={logoutclick}
      />

      <ExclusiveModal
        show={showModal}
        toggleModal={toggleModal}
        deeplinktext={deeplinktext}
      />
    </section>
  );
};
export default SidebarComponent;
